module.exports = __webpack_public_path__ + "img/active-1.bb3950fe.png";